import { render, staticRenderFns } from "./ShowImg.vue?vue&type=template&id=15fb2b60&scoped=true&"
import script from "./ShowImg.vue?vue&type=script&lang=js&"
export * from "./ShowImg.vue?vue&type=script&lang=js&"
import style0 from "./ShowImg.vue?vue&type=style&index=0&id=15fb2b60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb2b60",
  null
  
)

export default component.exports